import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../layouts/DashboardLayout";
import { Box, Container, Typography, Checkbox } from "@mui/material";
import useStyles from "./styles";
import CeroTable from "../../../../components/CeroTable";
import { useDispatch, useSelector } from "react-redux";
import { getSupplierRespondentList } from "../../../../redux/actions";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CeroPopUp from "../../../../components/CeroPopUp";
import CeroButton from "../../../../components/CeroButton";
import CloseIcon from "@mui/icons-material/Close";
import { STATUS } from "../../../../redux/constants";
import { useSnackbar } from "notistack";
import {
  resetSupplierScreeningStatus,
  sendRespondentReminder,
} from "../../../../redux/actions/supplierScreening";
import { resetSendRespondentReminderStatus } from "../../../../redux/actions/supplierScreening";
import { TextField, MenuItem, Tooltip, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { bulkSupplierAnswerAction } from "../../../../redux/actions/supplierScreening";

const SupplierProgressTable = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const [reminderPopup, setReminderPopup] = useState(false);
  const [actionPopup, setActionPopup] = useState(false);
  const [actionType, setActiontype] = useState(null);

  const surveyList = useSelector(
    (state) =>
      state.supplierScreening.getSupplierRespondentList?.data
        ?.survey_respondent_lst
  );
  const [reminderId, setReminderId] = useState(null);
  const reminderStatus = useSelector(
    (state) => state.supplierScreening.sendRespondentReminder
  );

  const actionStatus = useSelector(
    (state) => state.supplierScreening.bulkSupplierAnswerAction?.status
  );

  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  // FILTER + SEARCH LOGIC
  const filteredData = (surveyList || [])
    .filter((item) => (statusFilter ? item.status === statusFilter : true))
    .filter((item) =>
      search ? item.name.toLowerCase().includes(search.toLowerCase()) : true
    );

  const getData = () => {
    if (!Array.isArray(filteredData)) return [];

    return filteredData.map((item) => ({
      ...item,
      select: (
        <Checkbox
          className={classes.customCheckbox1}
          checked={selectedRows.includes(item.id)}
          onChange={() => toggleRow(item.id)}
        />
      ),
      status: getStatus(item.status),
      action: getAction(item.status, item.id),
    }));
  };
  const toggleRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((r) => r !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const toggleSelectAll = () => {
    if (selectedRows.length === filteredData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(filteredData.map((i) => i.id));
    }
  };

  useEffect(() => {
    id && dispatch(getSupplierRespondentList(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (actionStatus === STATUS.SUCCESS) {
      enqueueSnackbar(
        `${actionType === "Delete" ? "Deleted" : "Discarded"} successfully`,
        {
          variant: "success",
          key: "submit",
        }
      );
      dispatch(resetSupplierScreeningStatus());
      if (surveyList.length === selectedRows.length) navigate(-1);
      else {
        setSelectedRows([]);
        dispatch(getSupplierRespondentList(id));
      }
    }
    if (actionStatus === STATUS.ERROR) {
      enqueueSnackbar(
        reminderStatus?.data?.message ||
          "We couldn't process your request. Please try again later.",
        { variant: "error", autoHideDuration: 3000 }
      );
      dispatch(resetSupplierScreeningStatus());
    }
  }, [enqueueSnackbar, actionStatus, dispatch]);

  const onSendReminder = () => {
    reminderId && dispatch(sendRespondentReminder(reminderId));
    setReminderPopup(false);
  };

  useEffect(() => {
    if (reminderStatus?.status === STATUS.SUCCESS) {
      enqueueSnackbar(reminderStatus?.data?.message, {
        variant: "success",
        autoHideDuration: 3000,
      });
      dispatch(resetSendRespondentReminderStatus());
      setReminderPopup(false);
      dispatch(getSupplierRespondentList(id));
    } else if (reminderStatus?.status === STATUS.ERROR) {
      enqueueSnackbar(
        reminderStatus?.data?.message ||
          "We couldn't process your request. Please try again later.",
        { variant: "error", autoHideDuration: 3000 }
      );
      dispatch(resetSendRespondentReminderStatus());
    }
  }, [reminderStatus, id, enqueueSnackbar, dispatch]);

  const getActionConfirmation = () => {
    return (
      <>
        <CloseIcon
          onClick={() => setActionPopup(false)}
          className={classes.closeIcon}
        />
        <Typography variant="h6" fontWeight={600}>
          {actionType}
        </Typography>
        <Typography className={classes.popupContent}>
          {`Are sure to ${actionType} the Supplier Entery(s)`}
        </Typography>
        <Box className={classes.buttonContainer}>
          <CeroButton
            buttonText="Confirm"
            className={classes.buttonPrimary}
            onClick={() => {
              actionType === "Delete" ? onDelete() : onDiscard();
              setActionPopup(false);
            }}
          />
          <CeroButton
            buttonText="Cancel"
            variant="outlined"
            className={classes.buttonSecondary}
            onClick={() => setActionPopup(false)}
          />
        </Box>
      </>
    );
  };

  const getConfirmation = () => {
    return (
      <>
        <CloseIcon
          onClick={() => setReminderPopup(false)}
          className={classes.closeIcon}
        />
        <Typography variant="h6" fontWeight={600}>
          Send Reminder
        </Typography>
        <Typography className={classes.popupContent}>
          Are you sure you want to send reminder email to this Email ID?
        </Typography>
        <Box className={classes.buttonContainer}>
          <CeroButton
            buttonText="Confirm"
            className={classes.buttonPrimary}
            onClick={onSendReminder}
          />
          <CeroButton
            buttonText="Cancel"
            variant="outlined"
            className={classes.buttonSecondary}
            onClick={() => setReminderPopup(false)}
          />
        </Box>
      </>
    );
  };

  const getStatus = (status) => {
    if (status === "pending") {
      return <Typography className={classes.pending}>Pending</Typography>;
    } else if (status === "completed") {
      return <Typography className={classes.completed}>Completed</Typography>;
    }
  };

  const showReminder = (id) => {
    setReminderPopup(true);
    setReminderId(id);
  };

  const viewSurvey = (surveyId) => {
    navigate(`response/${surveyId}`);
  };

  const getAction = (status, id) => {
    if (status === "pending") {
      return (
        <Typography
          className={classes.reminder}
          onClick={() => showReminder(id)}
        >
          Send Reminder
        </Typography>
      );
    } else if (status === "completed") {
      //pending
      return (
        <Typography className={classes.view} onClick={() => viewSurvey(id)}>
          View Survey
        </Typography>
      );
    }
  };

  const surveyTrackColumns = [
    {
      columnKey: "select",
      columnId: "select",
      columnHeader: "", // Or "Select"

      width: "5vw",
    },
    {
      columnKey: "name",
      columnId: "name",
      columnHeader: "Name",
      width: "30vw",
    },
    {
      columnKey: "email",
      columnId: "email",
      columnHeader: "Email",
      width: "30vw",
    },
    {
      columnKey: "status",
      columnId: "status",
      columnHeader: "Status",
      width: "20vw",
    },
    {
      columnKey: "action",
      columnId: "action",
      columnHeader: "Action",
      width: "20vw",
    },
  ];

  // ---- DISCARD ----
  const onDiscard = () => {
    if (selectedRows.length === 0) return;

    dispatch(
      bulkSupplierAnswerAction({
        answer_ids: selectedRows, // top-level
        action: "discard", // top-level
      })
    );
  };

  // ---- DELETE ----
  const onDelete = () => {
    if (selectedRows.length === 0) return;

    dispatch(
      bulkSupplierAnswerAction({
        answer_ids: selectedRows, // top-level
        action: "delete", // top-level
      })
    );

    setSelectedRows([]);
  };

  return (
    <DashboardLayout>
      <Container className={classes.container}>
        <div
          className={classes.backContainer}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIosIcon />
          Back
        </div>
        {/* FILTERS ONLY */}
        <Box
          style={{
            display: "flex",
            gap: 20,
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          {/* Status Filter */}
          <TextField
            select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            label="Status"
            size="small"
            style={{ width: 180 }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
          </TextField>

          {/* Search */}
          <TextField
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            style={{ width: 280 }}
          />
        </Box>

        {/* PURPLE HEADER BAR ABOVE TABLE */}
        <Box className={classes.tableHeaderRow}>
          <Box style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {/* Select All */}
            <Checkbox
              className={classes.customCheckbox1}
              checked={
                filteredData.length > 0 &&
                selectedRows.length === filteredData.length
              }
              indeterminate={
                selectedRows.length > 0 &&
                selectedRows.length < filteredData.length
              }
              onChange={toggleSelectAll}
            />

            {/* Discard */}
            <Tooltip title="Discard">
              <Box
                className={classes.iconOnly}
                onClick={() => {
                  setActionPopup(true);
                  setActiontype("Discard");
                }}
              >
                <BlockIcon className={classes.smallIcon} />
              </Box>
            </Tooltip>

            <Tooltip title="Delete">
              <Box
                className={classes.iconOnly}
                onClick={() => {
                  setActionPopup(true);
                  setActiontype("Delete");
                }}
              >
                <DeleteIcon className={classes.smallIcon} />
              </Box>
            </Tooltip>
          </Box>
        </Box>

        <CeroTable
          columns={surveyTrackColumns}
          data={getData()}
          hasMore={false}
          loading={false}
          useExtraStyles={true}
          classes={{ tableContainer: classes.tableContainer }}
        />
        <CeroPopUp
          primaryPopUp={{
            open: reminderPopup,
            onClose: () => setReminderPopup(false),
            content: getConfirmation(),
            header: { title: "" },
          }}
          classes={{ dialog: classes.dialog }}
        />

        <CeroPopUp
          primaryPopUp={{
            open: actionPopup,
            onClose: () => setActionPopup(false),
            content: getActionConfirmation(),
            header: { title: "" },
          }}
          classes={{ dialog: classes.dialog }}
        />
      </Container>
    </DashboardLayout>
  );
};

export default SupplierProgressTable;
